export const DATASET_LABELS: Record<string, string> = {
  random: 'Acak',
  already_sorted: 'Sudah urut',
  reverse_sorted: 'Urut terbalik',
  nearly_sorted: 'Hampir urut',
  few_unique_values: 'Nilai unik sedikit',
  many_duplicates: 'Banyak duplikat',
  clustered: 'Berkelompok',
  uniform: 'Merata',
  skewed: 'Tidak seimbang',
  outlier_heavy: 'Banyak outlier',
  adversarial_quick_sort: 'Sulit untuk Quick Sort',
  complex_pattern: 'Pola kompleks',
};

export const DATASET_DESCRIPTIONS: Record<string, string> = {
  random: 'Data dibuat acak untuk melihat perilaku umum setiap algoritma.',
  already_sorted: 'Data sudah tersusun naik. Cocok untuk melihat algoritma yang adaptif.',
  reverse_sorted: 'Data tersusun turun. Biasanya lebih berat untuk beberapa algoritma sederhana.',
  nearly_sorted: 'Sebagian besar data sudah rapi, hanya sedikit posisi yang tertukar.',
  few_unique_values: 'Data punya sedikit jenis nilai, sehingga banyak angka terlihat mirip.',
  many_duplicates: 'Banyak nilai berulang. Cocok untuk melihat cara algoritma menangani duplikat.',
  clustered: 'Nilai berkumpul dalam beberapa kelompok.',
  uniform: 'Nilai tersebar relatif merata.',
  skewed: 'Nilai condong ke salah satu sisi rentang data.',
  outlier_heavy: 'Sebagian nilai jauh berbeda dari kelompok utama.',
  adversarial_quick_sort: 'Pola data yang sengaja dibuat kurang ramah untuk Quick Sort sederhana.',
  complex_pattern: 'Pola data buatan yang lebih alami dan tidak terlalu lurus.',
};

export const CATEGORY_LABELS: Record<string, string> = {
  comparison: 'Berbasis perbandingan',
  'non-comparison': 'Tanpa perbandingan langsung',
  hybrid: 'Gabungan beberapa teknik',
};

export function formatDatasetLabel(name: string): string {
  return DATASET_LABELS[name] ?? name.replace(/_/g, ' ');
}

export function getDatasetDescription(name: string, fallback = ''): string {
  return DATASET_DESCRIPTIONS[name] ?? fallback;
}

export function formatCategoryLabel(category: string): string {
  return CATEGORY_LABELS[category] ?? category;
}
